module.exports = __webpack_public_path__ + "img/certificate-place.6bca3fdc.png";